import request from '../utils/request'

export function getWxPcLoginQrCode() {
  return request({
    url: '/wxPcLogin/qrcode',
    method: 'get',
    headers: { isToken: false }
  })
}

export function getWxPcLoginStatus(loginId) {
  return request({
    url: '/wxPcLogin/status',
    method: 'get',
    params: { loginId },
    headers: { isToken: false }
  })
}

export function exchangeWxPcOauthTicket(ticket) {
  return request({
    url: '/wxPcLogin/oauth/exchange',
    method: 'post',
    data: { ticket },
    headers: { isToken: false }
  })
}
